import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16.84 18"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.67 15.3c5.6 0 8.66-4.63 8.66-8.66 0-.13 0-.27-.01-.39.59-.43 1.12-.97 1.52-1.58-.55.24-1.13.4-1.75.48.63-.38 1.12-.97 1.33-1.68-.59.35-1.24.61-1.94.74-.55-.59-1.35-.96-2.22-.96A3.039 3.039 0 0 0 8.3 6.99 8.742 8.742 0 0 1 2.04 3.8c-.27.44-.42.97-.42 1.52 0 1.05.54 1.99 1.36 2.53-.5-.01-.97-.15-1.39-.38v.04c0 1.47 1.05 2.71 2.44 2.99-.24.07-.51.11-.79.11-.2 0-.39-.01-.57-.05a3.037 3.037 0 0 0 2.84 2.11 6.1 6.1 0 0 1-3.78 1.31c-.24 0-.48-.01-.73-.04 1.35.85 2.95 1.36 4.67 1.36"
    }, null, -1)
  ])))
}
export default { render };